<template>
  <div class="wrappers" ref="wrappers">
    <LivePlayVideo
      :errorInfor="liveErrorInfor"
      :src="toHttps(liveStatus === 1 ? liveData.live_info.m3u8_url : '')"
      @onLoadVideoHeight="onLoadVideoHeight"
    />
    <!-- 直播操作栏（老师 讲义 选集） -->
    <LiveActionbar
      :showHandout="!!liveData.handout"
      @onOnlyTeacher="updateOnlyTeacher"
      @onHandout="showAppSheetText('handout')"
    />
    <!-- <div class="live-notice container">
            <div class="text"><img src="@/assets/images/live/playing/notice.png" class="icon"> 热点问答都在这里，点击展开查看</div>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <g>
                    <rect width="16" height="16" opacity="0" />
                    <path d="M339,314.99l4,4-4,4" transform="translate(326.99 -333) rotate(90)" fill="none"
                        stroke="#13bf80" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                </g>
            </svg>
        </div> -->
    <ChatList ref="ChatList" :showTeacher="isOnlyTeacher" :chatList="chatList" />

    <!-- 底部操作栏（礼物 提问 购物车） -->
    <BottomActionbar
      ref="BottomActionbar"
      @onZan="showAppSheetText('zan')"
      @onCar="showAppSheetText('car')"
      @onQuestion="showAppSheetText('question')"
      :showCar="!!liveData.live_info.s_no"
    />

    <!-- 侧边引导打开APP -->
    <SideOpenApp unitKey="CourseDetail" :options="{ no: liveData.course_no }" />

    <!-- 引导app行动面板-->
    <ActionSheetApp
      ref="ActionSheetApp"
      :text="appSheetText"
      unitKey="CourseDetail"
      :options="{ no: liveData.course_no }"
    />

    <div class="side-button-list">
      <div class="button" v-if="liveData.customer_info" @click="toURL(liveData.customer_info)">
        <img src="@/assets/images/live/playing/icon_wx.png" class="icon" />
      </div>

      <div class="button" v-if="liveData.lotteryInfo" @click="showAppSheetText('gift')">
        <img src="@/assets/images/live/playing/icon_gift.png" class="icon" />
      </div>

      <!-- customer_info -->
    </div>
  </div>
</template>
<script>
import SideOpenApp from '@/components/SideOpenApp.vue'
import minxinTim from '../mixins/minxinTim'
import LiveActionbar from '@/components/Playing/LiveActionbar.vue'
import BottomActionbar from '@/components/Playing/BottomActionbar.vue'
import ChatList from '@/components/Playing/ChatList.vue'
import ActionSheetApp from '@/components/Playing/ActionSheetApp.vue'
import LivePlayVideo from '@/components/Video/LivePlayVideo.vue'
export default {
  props: {
    liveData: Object,
    liveStatus: Number,
  },
  mixins: [minxinTim],
  data() {
    return {
      appSheetTextKey: '',
      videoHeight: 0, //视频高度
      chatListHeight: 0, //聊天区域高度
      availHeight: 0, //屏幕高度

      isOnlyTeacher: false,
    }
  },
  components: {
    LivePlayVideo,
    LiveActionbar,
    BottomActionbar,
    ChatList,
    ActionSheetApp,
    SideOpenApp,
  },
  computed: {
    appSheetText() {
      const list = {
        zan: '给老师点赞',
        car: '选购直播商品',
        question: '参与聊天互动',
        gift: '参与直播抽奖',
        handout: '查看直播讲义',
      }
      const text = list[this.appSheetTextKey]

      return `请前往${this.getCurrentBrand.name}APP，${text}`
    },
    liveErrorInfor() {
      const result = {}
      result.title = this.liveData.nostart.centralCourseName
      result.time = this.liveData.nostart.centralCourseLiveTime
      result.teacher = this.liveData.anchor_info.name
      result.liveText = ''

      // 直播状态 0未开始 1直播中 2直播结束 3可回放
      if (this.liveStatus === 0) {
        result.liveText = '直播未开始'
      }
      if (this.liveStatus === 2) {
        result.liveText = '直播已结束'
      }

      if (this.liveStatus === 1) {
        if (new Date().getTime() < new Date(this.liveData.live_info.live_start_time).getTime()) {
          result.liveText = '直播即将开始'
        }
      }

      return result
    },
    toHttps() {
      return function (url) {
        if (url.toString().indexOf('http://') >= 0) {
          url = url.toString().replace('http://', 'https://')
        }
        return url
      }
    },
  },
  mounted() {
    this.availHeight = this.$refs.wrappers.clientHeight
    this.initTimCoinfg()
    this.initTimSdk()
  },
  methods: {
    // 显示app引导提示
    showAppSheetText(key) {
      this.appSheetTextKey = key
      this.$refs.ActionSheetApp.showAppSheet()
    },
    // 监听视频高度加载完成
    onLoadVideoHeight(videoHeight) {
      this.videoHeight = videoHeight
      this.initChatListHeight()
    },
    initChatListHeight() {
      this.chatListHeight =
        this.availHeight -
        this.$refs.ChatList.$el.offsetTop -
        this.$refs.BottomActionbar.$el.offsetHeight
      this.$refs.ChatList.initHeight(this.chatListHeight)
    },
    initTimCoinfg() {
      const imInfor = this.liveData.live || {}
      this.sdkAppID = imInfor.appid
      this.userSig = imInfor.im_user_sig
      this.userID = imInfor.im_identifier
      this.groupID = imInfor.chatroom_id
    },
    updateOnlyTeacher(value) {
      this.isOnlyTeacher = value
    },
    // 调整url
    toURL(url) {
      window.location.open(url)
    },
  },
}
</script>
<style lang="scss" scoped>
.wrappers {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.live-notice {
  @include flex_center;
  height: 1rem;
  background-color: #ffffff;

  .text {
    flex: 1;
    display: flex;
    align-items: center;
    font-size: 0.32rem;
    font-weight: 500;
    color: var(--main-color);

    .icon {
      width: 0.43rem;
      margin-right: 0.16rem;
    }
  }

  .svg {
    stroke: var(--main-color);
  }
}

.side-button-list {
  position: fixed;
  right: 0.3rem;
  bottom: 3.8rem;

  .button {
    @include flex_center;
    width: 0.96rem;
    height: 0.96rem;
    background: #ffffff;
    box-shadow: 0rem 0rem 0rem rgba(0, 0, 0, 0.08);
    border-radius: 0.48rem;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.08);
    margin-top: 0.32rem;

    .icon {
      width: 0.53rem;
      height: 0.53rem;
    }
  }
}
</style>
